module.exports = __webpack_public_path__ + "img/MN.7bd9a92b.svg";